// Configuración de la aplicación
const config = {
  // URL de la API - cambiar según el entorno
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  
  // Configuración para diferentes entornos
  development: {
    API_BASE_URL: 'http://localhost:3001'
  },
  
  production: {
    // Asegurar que siempre tenga https:// al inicio
    API_BASE_URL: process.env.REACT_APP_API_URL 
      ? (process.env.REACT_APP_API_URL.startsWith('http') 
         ? process.env.REACT_APP_API_URL 
         : `https://${process.env.REACT_APP_API_URL}`)
      : 'https://prayer-api-production-9707.up.railway.app'
  }
};

// Determinar el entorno actual
const isDevelopment = process.env.NODE_ENV === 'development';
const currentConfig = isDevelopment ? config.development : config.production;

const appConfig = {
  ...config,
  ...currentConfig
};

// Debug: verificar la URL que se está usando
console.log('🔧 Config API URL:', appConfig.API_BASE_URL);
console.log('🔧 NODE_ENV:', process.env.NODE_ENV);
console.log('🔧 REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

export default appConfig; 